import { Skeleton } from '@mui/material'

import { Wrapper } from './styles'

interface ISkeletonLoadingProps {
	children?: React.ReactNode
	height?: string
}

const SkeletonLoading = ({
	children,
	height = '500px',
}: ISkeletonLoadingProps) => (
	<Wrapper>
		<Skeleton width="100%" height={height}>
			{children}
		</Skeleton>
	</Wrapper>
)

export { SkeletonLoading }
